enum EventHandledCode {
  OK = 'OK',
  FAILED = 'FAILED',
}
export default EventHandledCode;
